/**
 * A post-login `returnTo` comes from the URL and is therefore attacker-controlled.
 * Only same-origin paths are allowed; anything absolute is an open redirect.
 */
export function safeRedirect(candidate: string | null | undefined, fallback = '/'): string {
  if (!candidate) return fallback
  // Rejects `https://evil.com`, `//evil.com` and `\\evil.com` alike.
  if (!candidate.startsWith('/') || candidate.startsWith('//') || candidate.startsWith('/\\')) {
    return fallback
  }
  return candidate
}

const SAFE_URL_SCHEMES = new Set(['http:', 'https:', 'mailto:'])

/** A `href` or `src` taken from data must be checked — `javascript:` is XSS. */
export function safeUrl(candidate: string | null | undefined): string | undefined {
  if (!candidate) return undefined
  try {
    const url = new URL(candidate, globalThis.location?.origin ?? 'http://localhost')
    return SAFE_URL_SCHEMES.has(url.protocol) ? candidate : undefined
  } catch {
    return undefined
  }
}
